export type { TourDataSource, PropertyCredentials, TourSourceId, TourTypeOverride } from './types';
export { EntrataSource } from './entrata';
export { YardiSource } from './yardi';

import type { TourDataSource } from './types';
import { EntrataSource } from './entrata';
import { YardiSource } from './yardi';

/**
 * Create a tour data source by type. Falls back to Yardi for unknown ids
 * (preserves legacy behavior — `source` token defaults to 'yardi').
 */
export function createSource(type: string): TourDataSource {
  switch (type) {
    case 'entrata':
      return new EntrataSource();
    case 'yardi':
    default:
      return new YardiSource();
  }
}
